import React from "react";

import { useFormikContext } from "formik";
import { useSelector } from "react-redux";

import EIDsCollapse from "components/DetailedSaleLotModal/EIDsCollapse";
import { ScanningDetails } from "components/DetailedSaleLotModal/ScanningCollapse";
import { ForLivestockSale } from "containers/ForSaleType";
import { withNamespace } from "components/Form/FormikControls/lib";
import { getConsignmentById } from "selectors";
import { useToggle } from "hooks";

import { MobileTransactionalCreateSaleFormValues } from "../lib/types";

import { Grid } from "@material-ui/core";
import { FormRow } from "./FormRow";
import { Input } from "components/Form/FormikControls";

interface NlisTabProps {
  saleLotId: string;
  saleLotNamespace: string;
}

export const NlisTab = ({ saleLotId, saleLotNamespace }: NlisTabProps) => {
  const { values } = useFormikContext<MobileTransactionalCreateSaleFormValues>();
  const [isEIDsOpen, toggleEIDs] = useToggle(false);

  const consignment = useSelector(
    getConsignmentById(values.saleLot.consignment_id),
  );
  const vendorPropertyId = consignment?.vendor_property_id;

  const quantity = values.saleLot.quantity ?? 0;
  const quantityProgeny = values.saleLot.quantity_progeny ?? 0;

  return (
    <ForLivestockSale>
      <>
        <ScanningDetails
          saleLotId={saleLotId}
          quantity={quantity}
          quantityProgeny={quantityProgeny}
          readOnly={false}
        />
        <FormRow>
          <Grid item xs={12}>
            <Input
              label="Tags Used Quantity"
              name={withNamespace(saleLotNamespace, "quantityTagsUsed")}
              tooltip="The number of tags required (including replacement and new tags) for this Sale Lot. "
              type="number"
              min={0}
            />
          </Grid>
        </FormRow>
        <EIDsCollapse
          isOpen={isEIDsOpen}
          onToggle={toggleEIDs}
          saleLotId={saleLotId}
          vendorPropertyId={vendorPropertyId}
          readOnly={false}
        />
      </>
    </ForLivestockSale>
  );
};
